import type { Key } from '@/root/shared-hooks/useGetTranslations/useGetTranslations'

const INSUFFICIENT_CAPACITY_MESSAGE_KEYS: Record<string, Key> = {
  passengers: 'editErrorNoPassengerSeats',
  vehicles: 'editErrorNoVehicleSpace',
  bicycles: 'editErrorNoBicycleSpace',
}

/**
 * Maps the first insufficient-capacity reason to its warning translation key.
 * Returns undefined for an empty reason list or an unknown reason.
 */
export const getInsufficientCapacityMessageKey = (reasons: string[]): Key | undefined => {
  const firstReason = reasons[0]
  return firstReason ? INSUFFICIENT_CAPACITY_MESSAGE_KEYS[firstReason] : undefined
}
